export const PLAYGROUND_EXTRACTION_METHODS = [
  'Neurix Layout',
  'Neurix Layout 2.0',
  'Lite Parse',
];

// Reducer models accepted by the chunking service (`reducer_model` in
// POST /v1/documents — see backend/chunking_service/infrastructure/request_config.py).
export const PLAYGROUND_REDUCER_MODELS = [
  { id: 'deepseek-v4.1-flash', name: 'DeepSeek V4.1 Flash' },
  { id: 'DeepSeek-V4-Pro', name: 'DeepSeek V4 Pro' },
  { id: 'gpt-6-luna', name: 'GPT 6-luna' },
];

export const PLAYGROUND_MODELS = [
  'GPT 4.1',
  'GPT 5.6-luna',
  'GPT 5.4-mini',
  'DeepSeek V4 Pro',
  'Claude Haiku 5.5',
  'DeepSeek V4.1 Flash',
  'GPT 6-luna',
];

// Models that take a reasoning effort instead of a temperature.
export const PLAYGROUND_REASONING_MODELS = [
  'GPT 5.4-mini',
  'GPT 5.6-luna',
  'DeepSeek V4 Pro',
  'GPT 6-luna',
];

// Models with no tunable settings (Claude Haiku 5.5 rejects non-default sampling).
export const PLAYGROUND_FIXED_SETTINGS_MODELS = [
  'Claude Haiku 5.5',
];

export const PLAYGROUND_MODEL_NAME_MAPPING = {
  'GPT 4.1': 'GPT 4.1',
  'GPT 5.6-luna': 'gpt-5.6-luna',
  'GPT 5.4-mini': 'gpt-5.4-mini',
  'DeepSeek V4 Pro': 'DeepSeek-V4-Pro',
  'Claude Haiku 5.5': 'claude-haiku-5-5',
  'DeepSeek V4.1 Flash': 'deepseek-v4.1-flash',
  'GPT 6-luna': 'gpt-5.6-luna',
};

export const PLAYGROUND_TEST_MODEL_OPTIONS = [
  { id: 'GPT 4.1', name: 'GPT 4.1', description: 'Advanced reasoning' },
  { id: 'GPT 5.6-luna', name: 'GPT 5.6-luna', description: '5.6 luna version' },
  { id: 'GPT 5.4-mini', name: 'GPT 5.4-mini', description: '5.4 mini version' },
  { id: 'DeepSeek V4 Pro', name: 'DeepSeek V4 Pro', description: 'Reasoning model (same as the reducer agent)' },
  { id: 'Claude Haiku 5.5', name: 'Claude Haiku 5.5', description: 'Fast model' },
  { id: 'DeepSeek V4.1 Flash', name: 'DeepSeek V4.1 Flash', description: 'Fast DeepSeek model (same as the chunking Flash reducer)' },
  { id: 'GPT 6-luna', name: 'GPT 6-luna', description: 'Luna on the Vibe gateway (same as the chunking reducer)' },
];
